import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function PlusIcon({
  className,
  color = "currentColor",
  size,
  strokeWidth = "2",
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <path
        d="M4 12L20 12M12 4V20"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
